<section class="ph" aria-labelledby="profileName">
  <div class="ph__cover" [class.ph__cover--default]="isStockBanner" [style.background-image]="'url(' + banner + ')'">
    @if (isOwn) {
      <button type="button" class="ut-btn ut-btn--secondary ut-btn--sm ph__cover-btn" (click)="edit('banner')">
        <span class="material-icons" aria-hidden="true">photo_camera</span>
        Edit banner
      </button>
    }
  </div>

  <div class="ph__main">
    <div class="ph__avatar">
      <img [src]="user.avatar_url" alt="" width="120" height="120" />
      @if (isOwn) {
        <button type="button" class="ph__avatar-btn" aria-label="Edit avatar" (click)="edit('avatar')">
          <span class="material-icons" aria-hidden="true">photo_camera</span>
        </button>
      }
    </div>

    <div class="ph__id">
      <h1 class="ph__name" id="profileName">
        {{ user.name }}
        @if (user.plus_tester_rating_id) {
          <span class="ph__badge ph__badge--purple">Plus tester</span>
        }
        @if (user.follow_stats?.follows_current_user) {
          <span class="ph__badge">Follows you</span>
        }
      </h1>
      @if (user.user_title) {
        <p class="ph__title">{{ user.user_title }}</p>
      }
      <div class="ph__meta">
        <span>&#64;{{ user.slug }}</span>
        @if (isOwn && me?.platform_id) {
          <span>Platform ID {{ me.platform_id }}</span>
        }
        <!-- Location and role always start a second row. -->
        <span class="ph__meta-break" aria-hidden="true"></span>
        @if (user.country?.name) {
          <span><span class="material-icons" aria-hidden="true">place</span>{{ user.country.name }}</span>
        }
        <span><span class="material-icons" aria-hidden="true">person_outline</span>{{ role }}</span>
        @if (user.social_network_urls?.twitter) {
          <a class="ph__social" [href]="'https://x.com/' + user.social_network_urls.twitter" target="_blank" rel="noopener" aria-label="X profile">
            <span class="icon-x-material" aria-hidden="true"></span>
          </a>
        }
        @if (linkedIn) {
          <a class="ph__social" [href]="linkedIn" target="_blank" rel="noopener" aria-label="LinkedIn profile">
            <span class="icon-linkedin-material" aria-hidden="true"></span>
          </a>
        }
      </div>
      @if (isOwn && me) {
        <p class="ph__referral">
          <span class="material-icons" aria-hidden="true">link</span>
          <span class="ph__referral-label">Referral link</span> <code class="ph__referral-link">{{ referralLink }}</code>
          <button type="button" class="ph__referral-copy" [title]="copied() ? 'Copied!' : 'Copy referral link'"
            [attr.aria-label]="copied() ? 'Copied!' : 'Copy referral link'" (click)="copyReferral()">
            @if (!copied()) {
              <img src="/utest-static/assets/images/icons/copy-01.svg" alt="" aria-hidden="true" width="16" height="16" />
            } @else {
              <svg class="ph__referral-check" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M2 8.5L6 12.5L14 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            }
          </button>
          <!-- A changed label on the focused button isn't reliably re-read, so announce the copy too. -->
          <span class="sr-only" aria-live="polite">{{ copied() ? 'Referral link copied' : '' }}</span>
        </p>
      }
    </div>

    <div class="ph__actions">
      @if (isOwn) {
        <a class="ut-btn" [href]="editProfileLink">
          <span class="material-icons" aria-hidden="true">edit</span>
          Edit profile
        </a>
      } @else {
        @if (canMention) {
          <button type="button" class="ut-btn ut-btn--secondary" (click)="mention()">
            <span class="material-icons" aria-hidden="true">alternate_email</span>
            Mention
          </button>
        }
        @if (canFollow) {
          <ut-community-follow-btn [user]="user" design="2026"></ut-community-follow-btn>
        }
      }
    </div>
  </div>

  <div class="ph__stats">
    <div class="ph__stat">
      <span class="ph__stat-label">uPoints</span>
      <span class="ph__stat-value">{{ user.points | number }}</span>
    </div>
    @if (showRank) {
      <div class="ph__stat">
        <span class="ph__stat-label">uPoints rank</span>
        <span class="ph__stat-value">#{{ user.rank | number }} <small>of {{ user.global_lowest_rank | number }}</small></span>
      </div>
    }
    <a class="ph__stat" uiSref="profile.followers" [uiParams]="{ profileId: user.slug }">
      <span class="ph__stat-label">Followers</span>
      <span class="ph__stat-value">{{ user.follow_stats.follower_count | number }}</span>
    </a>
    <a class="ph__stat" uiSref="profile.following" [uiParams]="{ profileId: user.slug }">
      <span class="ph__stat-label">Following</span>
      <span class="ph__stat-value">{{ followingCount | number }}</span>
    </a>
  </div>

</section>
